// ** React Imports
import React, { ChangeEvent, FC } from 'react'

// ** MUI Imports
import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material'
import { RadioItemConfigType } from 'src/lib/types/discounts'
import Permission from 'src/services/PermissionService'
import { Info } from 'react-feather'

interface FloRadioGroupProps {
  selectedOption: string | boolean | undefined
  setSelectedOption: any
  options: RadioItemConfigType[] | undefined
  groupName: string
  isDisabled?: boolean
  customClassName?: string
  color?: string
  activeColor?: string
  labelCustomClass?: string
  customCSS?: any
  hasBorder?: boolean
}

const FloRadioGroup: FC<FloRadioGroupProps> = ({
  selectedOption,
  setSelectedOption,
  options,
  groupName,
  isDisabled = false,
  customClassName,
  color,
  activeColor,
  labelCustomClass,
  customCSS,
  hasBorder = false
}) => {
  return (
    <RadioGroup
      name={groupName}
      value={selectedOption}
      onChange={(event: ChangeEvent<HTMLInputElement>) => {
        setSelectedOption((event.target as HTMLInputElement).value)
      }}
      className='w-full '
    >
      <div className={`flex flex-col ${customClassName} cursor-${isDisabled ? 'pointer' : 'not-allowed'}`}>
        {options?.map((item: RadioItemConfigType, index: number) => {
          const controlEl = () => (
            <div
              className={`${hasBorder ? 'border-1 border-coal-dark px-2 py-4 rounded-lg cursor-pointer' : ''} ${
                item.valueType !== selectedOption ? 'border-none' : ''
              }`}
              id={`${groupName}-${item?.valueType}`}
              onClick={() => {
                if (hasBorder && !item.isDisabled) setSelectedOption(item?.valueType)
              }}
              key={`${item?.valueType}_${index}`}
            >
              <FormControlLabel
                key={`${item?.valueType}_${index}`}
                disabled={item?.isDisabled || isDisabled}
                value={item?.valueType}
                sx={customCSS}
                control={
                  <Radio
                    size='small'
                    sx={{
                      padding: '4px 10px 4px 10px',
                      color:
                        Boolean(activeColor) && selectedOption === item.valueType
                          ? `${activeColor} !important`
                          : Boolean(color)
                          ? `${color} !important`
                          : '#4D4D4D !important'
                    }}
                  />
                }
                label={
                  <div className='flex flex-col'>
                    <p className={`text-sm mt-[6px] ${labelCustomClass}`}>{item?.label}</p>
                    {Boolean(item?.description) && (
                      <span className='pt-1 mb-2 text-sm font-normal text-gray-dark'>{item?.description}</span>
                    )}
                    {Boolean(item?.errorMsg) && item?.isDisabled && (
                      <div className='flex gap-2 text-xs bg-[#E49B9B33] py-1 px-2 mt-2 text-orchid-dark rounded-lg'>
                        <Info className='h-4' />
                        <p className={item?.errorMsgCSS}>{item?.errorMsg}</p>
                      </div>
                    )}
                  </div>
                }
                className='flex !items-start'
              />
            </div>
          )
          if (Boolean(item.permissionId)) {
            return (
              <Permission
                permissionId={item.permissionId ?? ''}
                key={`${item?.valueType}_${index}`}
                message={item?.tooltipMessage}
              >
                {controlEl()}
              </Permission>
            )
          }
          return <>{controlEl()}</>
        })}
      </div>
    </RadioGroup>
  )
}

export default FloRadioGroup
